import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onYes: () => void,
    onNo: () => void
}

const ConfirmNotFullyConfident = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Not Fully Confident</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                You have accepted the donor as Not Fully Confident. Based on your patients cPRA we will order an EXM for this patient.
                If you are fully confident in your VXM, please click "No, Cancel" below and change your answer to Fully Confident.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes, Confirmed</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmNotFullyConfident;